import options from './thing-picture.component';

export default {
    selector: 'dtAsThingPicture',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-picture/index.js